import { createAsyncThunk } from '@reduxjs/toolkit';
import ReportService from '../../../../services/report.service';
import { VehicleGeofenceFilters } from '../types';

export const getVehicleGeofenceReport = createAsyncThunk(
  'reports/getVehicleGeofenceReport',
  async (filters: VehicleGeofenceFilters, { rejectWithValue }) => {
    const response = await ReportService.getVehicleGeofenceReport(filters);
    if (response.ok) {
      return response.data;
    }
    return rejectWithValue(response.error);
  },
);
